export default __webpack_public_path__ + "static/media/part_2_con2.9fb4ad3c.gif";